module.exports = __webpack_public_path__ + "img/lisa_thak.b3985f72.png";